import React from "react";

import { Box, BoxOwner } from "../../../../../dtos/box";
import { BoxFeatureSetup } from "../types";

import { AddOwnerFlow } from "./AddOwnerFlow";
import { BankBoxCheckbox } from "./BankBoxCheckbox";

interface Props {
    owners: BoxOwner[];
    box: Box;
    onUpdate: () => void;
    boxFeatures: BoxFeatureSetup;
}

export function BoxOwnersHeader({
    box,
    owners,
    onUpdate,
    boxFeatures,
}: Props) {

    return (
        <div
            style={{
                display: "flex",
                justifyContent: "space-between",
                flexWrap: "wrap",
            }}
        >
            <h2 style={{ flexGrow: 1, flexShrink: 0 }}>
                Owner Info
            </h2>

            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "20px",
                    flexWrap: "wrap",
                }}
            >
                <BankBoxCheckbox
                    box={box}
                    onIsBankBoxChanged={onUpdate}
                    feature={boxFeatures.bankBoxToggle}
                />


                <AddOwnerFlow
                    box={box}
                    owners={owners}
                    onBoxOwnerAdded={onUpdate}
                    boxFeatures={boxFeatures}
                />
            </div>
        </div>
    );
}
